BookingApp.directive('flightTravellers',function(){
    return {
        restrict:'E',
        transclude:false,
        scope:{
            label:'@',
            count:'=',
            min:'=',
            max:'='
        },
        template:'<div class="stepper-widget">'+
                    '<label>{{ label }}</label>'+
                    '<button type="button" class="js-qty-down btn btn-default">-</button>'+
                    '<input type="text" ng-model="count" class="js-qty-input form-control" value="1" />'+
                    '<button type="button" class="js-qty-up btn btn-default">+</button>'+
                '</div>',
        link:function(scope,element,attrs){

            element.find('.js-qty-down').click(function (e) {
                if(scope.count <= scope.min) return;
                scope.count--;
                scope.$apply();
            })

            element.find('.js-qty-up').click(function (e) {
                //console.log(scope.count)
                if(scope.count >= scope.max) return;
                scope.count++;
                scope.$apply();
            })
        }
    }
})
